import { render, staticRenderFns } from "./OnlineClassManageIndex.vue?vue&type=template&id=37e391ee&scoped=true&"
import script from "./OnlineClassManageIndex.vue?vue&type=script&lang=js&"
export * from "./OnlineClassManageIndex.vue?vue&type=script&lang=js&"
import style0 from "./OnlineClassManageIndex.vue?vue&type=style&index=0&id=37e391ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e391ee",
  null
  
)

export default component.exports